import { useEffect, useRef } from 'react'

export const useOneShot: (effect: () => void) => void = (effect) => {
    const didCalled = useRef(false);
    useEffect(() => {
        if (didCalled.current === false) {
            didCalled.current = true
            effect()
        }
    }, [])
}
